import React, {useRef, useEffect, useState} from "react";
import useCamera from "./hook";
import LoaderLulo from "../../../../components/loaderLulo";
import Loader from "../../../../components/loader";
import "./index.css";
import {useLocation} from "react-router-dom";
import {initDevice} from "../../../../utils/camera-utils";
import {forceFocus, optimizeImageQuality} from "../../utils";

export function WrapperCardCaptureV6() {
    const location = useLocation();
    const [config, setConfig] = useState({});
    const [configLoading, setLoading] = useState(true);

    // get project name from query params
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    const projectName = params.projectName || 'Default'

    // get the url based on the current page
    const url = () => {
        if (location.pathname.includes('card-capture')) {
            return `https://lnesv3-conf.ado-tech.com/${projectName}/CardCapture/config.json`;
        }
        return `https://lnesv3-conf.ado-tech.com/${projectName}/Liveness/config.json`;
    }
    const defaultUrl = () => {
        if (location.pathname.includes('card-capture')) {
            return `https://lnesv3-conf.ado-tech.com/Default/CardCapture/config.json`;
        }
        return `https://lnesv3-conf.ado-tech.com/Default/Liveness/config.json`;
    }

    function setStyles(stylesObject) {
        const root = document.documentElement;
        root.style.setProperty('--background-color', stylesObject.backgroundColor);
        root.style.setProperty('--message-color', stylesObject.messageColor);
        root.style.setProperty('--message-back-color', stylesObject.messageBackgroundColor);
        root.style.setProperty('--guide-color', stylesObject.guideColor);
        root.style.setProperty('--success-color', stylesObject.successColor);
        root.style.setProperty('--error-color', stylesObject.errorColor);
        root.style.setProperty('--message-error-color', stylesObject.messageErrorColor);
        root.style.setProperty('--font-size', stylesObject.fontSize);
    }

    const fetchConfig = async () => {
        try {
            const response = await fetch(url(), { method: 'GET' });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log('data ->', data);
            setConfig(data);
            setStyles(data.styles)
        } catch (error) {
            const response = await fetch(defaultUrl(), { method: 'GET' });
            const data = await response.json();
            setConfig(data);
            setStyles(data.styles)
            console.error("Failed to fetch config:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchConfig();
    }, []);

    if (configLoading) {
        return null
    }

    console.log('config afuera', config);
    return (
        <CardCaptureV6 configLoading={configLoading} configValue={config} />
    )
}

export default function CardCaptureV6({configValue, configLoading}) {
    const lottieRef = useRef(null);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const guideAdo = useRef(null)
    const textPreviewBack = useRef(null)
    const textPreview = useRef(null)
    const imgBack = useRef(null)
    const takeManual = useRef(null)
    const containerAdo = useRef(null)

    const {
        platform,
        loading,
        projectName,
        typeCapture,
        goBack,
        isMovil,
        takeManualPhoto,
        emitReadyCam,
    } = useCamera({containerAdo, configLoading, configValue, videoRef, canvasRef, guideAdo, textPreviewBack, textPreview, imgBack, takeManual})

    useEffect(() => {
        const animation = lottieRef.current;
        if (animation) {
            animation.setSpeed(2.5);
            animation.play();
        }
    }, [])

    // Función para manejar tap-to-focus en iOS
    const handleVideoTap = async (event) => {
        if (initDevice().isIos) {
            event.preventDefault()
            await forceFocus(videoRef)
            await optimizeImageQuality(videoRef)
        }
    }
    // 300 y 500

    // if (isMovil()) {
        return (
            <div ref={containerAdo} className={`container v6 movil ${projectName.toLowerCase().includes('lulo') ? 'background-lulo' : 'background-default'}`}>
                {(loading && emitReadyCam !== 'true') && (
                    <div className="loader-container">
                        {projectName.toLowerCase().includes('lulo') ? (
                            <LoaderLulo />
                        ) : (
                            <Loader color="#FFF" primary="#FF3D00" />
                        )}
                    </div>
                )}
                <div onClick={goBack} className="img-back" ref={imgBack}></div>

                <div>
                    <div ref={guideAdo} className={`guide-ado ${platform === 'web' ? 'margin-top-web' : ''} ${isMovil() ? 'movil' : 'desk'}`}>
                        {configValue.styles.showGuide && <div className="dashed-marked"></div>}
                        <video
                            onClick={handleVideoTap}
                            id="video-camera"
                            className={`container-camera-movil video-movil ${isMovil() ? 'movil' : 'desk'}`}
                            ref={videoRef}
                            controls={false}
                            autoPlay
                            playsInline
                            muted
                            style={{
                                WebkitAppearance: "none",
                                appearance: "none",
                            }}
                        />
                        {typeCapture === '1' ? (
                            <div className="type-capture-1">
                                <div ref={textPreview} className="text-preview text-guide">
                                    Ubíca la parte de adelante de tu documento
                                </div>
                            </div>
                        ) : (
                            <div className="type-capture-2">
                                <div ref={textPreviewBack} className="text-preview-back text-guide">
                                    Ubica la parte de adelante de tu documento
                                </div>
                            </div>
                        )}
                    </div>

                    <div ref={takeManual} onClick={takeManualPhoto} className="take-manual">
                        <div className="take-manual-inner" />
                    </div>
                </div>
                <canvas id="canvas-view" className="canvas-view" ref={canvasRef} />
                <img alt="imgResult" id="imgResult" className="img-result" />
                <div id="message-alert-ado" className="message-alert-ado">
                    <h2>Error al validar el documento</h2>
                    <p>Verifique que el documento se vea correctamente</p>
                </div>
            </div>
        )
    // }


    // return (
    //     <div style={{backgroundColor: '#000'}} className="container__camera">
    //         {debug === 'true' && (
    //             <>
    //                 <div style={{
    //                     position: 'absolute',
    //                     zIndex: 200,
    //                     width: '100%',
    //                     top: 0,
    //                     display: 'flex',
    //                     justifyContent: 'space-around'
    //                 }}>
    //                     <div>
    //                         <h5 style={{color: 'white'}}>Image</h5>
    //                         <h5 style={{color: 'white'}}>{isImageValidate ? 'Si' : 'No'}</h5>
    //                     </div>
    //                     <div>
    //                         <h5 style={{color: 'white'}}>OCR</h5>
    //                         <h5 style={{color: 'white'}}>{ocr}</h5>
    //                     </div>
    //                     <div>
    //                         <h5 style={{color: 'white'}}>isCard</h5>
    //                         <h5 style={{color: 'white'}}>{isCard}</h5>
    //                     </div>
    //                 </div>
    //             </>
    //         )}


    //         <div id="container-ado-camera" style={{
    //             position: 'absolute',
    //             top: '50%',
    //             left: '50%',
    //             transform: 'translate(-50%, -50%)'
    //         }}>
    //             <video id="video-camera" className={`container__camera-camera ${!isMovil() ? 'video-mirror' : ''}`}
    //                    ref={videoRef} autoPlay playsInline/>
    //         </div>

    //         <div onClick={goBack} className="imgback" id="img-back-ado">
    //             X
    //         </div>

    //         <input id="input-ado-copy" style={{display: 'none', width: '90%', padding: 20}}/>
    //         <canvas id="canvas-view" ref={canvasRef} style={{display: 'none'}}/>

    //         <img alt="imgResult" id="imgResult" style={{display: 'none', width: '100%'}}/>
    //         {debug === 'true' && (
    //             <>
    //                 <div style={{
    //                     position: 'absolute',
    //                     width: '100%',
    //                     bottom: '8rem',
    //                     display: 'flex',
    //                     justifyContent: 'space-around'
    //                 }}>
    //                     <div>
    //                         <div style={{height: 200, overflowY: 'scroll', display: 'none'}}>
    //                             <h5 style={{color: 'white'}}>Step history</h5>
    //                             {stepHistory.map(step => (
    //                                 <h5 style={{color: 'white'}}>{step}</h5>
    //                             ))}
    //                         </div>

    //                         <div style={{marginTop: 10}}>
    //                             <h5 style={{color: 'white'}}>Current Step</h5>
    //                             <h5 style={{color: 'white'}}>{step}</h5>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </>
    //         )}
    //     </div>
    // )
}
